import { render, staticRenderFns } from "./BackPage.vue?vue&type=template&id=7814f835&scoped=true"
import script from "./BackPage.vue?vue&type=script&lang=js"
export * from "./BackPage.vue?vue&type=script&lang=js"
import style0 from "./BackPage.vue?vue&type=style&index=0&id=7814f835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7814f835",
  null
  
)

export default component.exports